// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PwGB","toggle":"styles_toggle__3LxEh","preview":"styles_preview__3rgW7"};